module.exports = __webpack_public_path__ + "static/media/gradient-stopoffset-icon.f8d5a147.svg";